import type { ReactNode } from 'react'
import { PhantomProvider, darkTheme } from '@phantom/react-sdk'
import { WALLET_PROVIDERS } from '@/config/profile'
import { AddressType } from '@phantom/browser-sdk'

const phantomAppId = import.meta.env.VITE_PHANTOM_APP_ID?.trim()
const phantomAppIcon = WALLET_PROVIDERS.find((provider) => provider.id === 'phantom')?.iconUrl

export function PhantomWalletProvider({ children }: { children: ReactNode }) {
	return (
		<PhantomProvider
			config={{
				providers: ['injected'],
				addressTypes: [AddressType.solana],
				appId: phantomAppId,
			}}
			theme={darkTheme}
			appIcon={phantomAppIcon}
			appName='BetsCycle'
		>
			{children}
		</PhantomProvider>
	)
}
